import React, { useState , useEffect} from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { connect, useDispatch, useSelector} from 'react-redux';

import {
  Box,
  Button,
  Checkbox,
  Container,
  FormHelperText,
  Link,
  TextField,
  Typography,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import { alertActions, userActions } from '../../_actions';
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const RegisterView = () => {

  const classes = useStyles();
  const navigate = useNavigate();
  const [submitted, setSubmitted] = useState(
    {
      label: 'Registrarse Ahora',
      state: false
    }
  );
  const registering = useSelector(state => state.registration.isregitered);
  const dispatch = useDispatch();
  useEffect(() => { 
    dispatch(alertActions.clear()); 
  }, []);
  return (
    <Page
      className={classes.root}
      title="Register"
    >
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              email: '',
              firstName: '',
              lastName: '',        
              
              
            }}
            validationSchema={
              Yup.object().shape({
                email: Yup.string().email('Dirección de email no valida').max(255).required('Email es requerido'),
                firstName: Yup.string().max(255).required('El Nombre es un campo requerido'),
                lastName: Yup.string().max(255).required('El Apellido es un campo requerido'),                
              })
            }
            onSubmit={(values,actions) => {
              setSubmitted({
              label: 'Cargando...',
              state: true
              });        
             
              dispatch(userActions.register(values))
              setTimeout(function(){
                setSubmitted({
                  label: 'Registrarse Ahora',
                  state: false
                  });
                  actions.resetForm({values :''});
            }, 700);
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mb={3}>
                  <Typography
                    color="textPrimary"
                    variant="h2"
                  >
                   Crear una nueva cuenta
                  </Typography>
                  <Typography
                    color="textSecondary"
                    gutterBottom
                    variant="body2"
                  >
                   Usa tu email para crear una nueva cuenta
                  </Typography>
                </Box>
                <TextField
                  error={Boolean(touched.firstName && errors.firstName)}
                  fullWidth
                  helperText={touched.firstName && errors.firstName}
                  label="Nombre"
                  margin="normal"
                  name="firstName"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.firstName}
                  variant="outlined"
                />
                <TextField
                  error={Boolean(touched.lastName && errors.lastName)}
                  fullWidth
                  helperText={touched.lastName && errors.lastName}
                  label="Apellido"
                  margin="normal"
                  name="lastName"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.lastName}
                  variant="outlined"
                />
                <TextField
                  error={Boolean(touched.email && errors.email)}
                  fullWidth
                  helperText={touched.email && errors.email}
                  label="Email"
                  margin="normal"
                  name="email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="email"
                  value={values.email}
                  variant="outlined"
                />             
              
              <Box my={2}>
                    <Button
                      color="primary"
                      disabled={submitted.state}
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                    >            
                    {submitted.label}                    
                    </Button>
                </Box>
                <Typography
                  color="textSecondary"
                  variant="body1"
                >
                  ¿Usted tiene una cuenta?
                  {' '}
                  <Link
                    component={RouterLink}
                    to="/login"
                    variant="h6"
                  >
                    Iniciar Sesión
                  </Link>
                </Typography>
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </Page>
  );
};

export default RegisterView;
